import {useState} from 'react';
import {useAuthentication} from "../../auth/AuthProvider";

// https://usehooks.com/useLocalStorage/

function useLocalStorage(topicKey: string, initialValue: any) {
    const {getUser} = useAuthentication();
    let storageKey: string;
    getUser().then(u => storageKey = topicKey + (u && u.Id));

    const [storedValue, setStoredValue] = useState(() => {
        try {
            const item = window.localStorage.getItem(storageKey);
            return item ? JSON.parse(item) : initialValue;
        } catch (error) {
            console.log(error);
            return initialValue;
        }
    });

    const setValue = (value: any) => {
        try {
            const valueToStore = value instanceof Function ? value(storedValue) : value;
            setStoredValue(valueToStore);
            window.localStorage.setItem(storageKey, JSON.stringify(valueToStore));
        } catch (error) {
            console.log(error);
        }
    };
    return [storedValue, setValue];
}

export default useLocalStorage;
